import { PouchDB } from "./PouchDB";
import { IObjectStore } from "../../domain/store/IObjectStore";

export class PouchDbStore<T> implements IObjectStore<T> {

    protected db: PouchDB.Database<{}>;

    constructor(name: string) {
        this.db = new PouchDB(name);
    }
    getId(item: T): string {
        return (item as any)._id;
    }
    getAll(): Promise<Array<T>> {
        // get all items from storage including details
        return this.db.allDocs({
            include_docs: true
        })
            .then(db => {
                // re-map rows to collection of items
                return db.rows.map(row => {
                    return row.doc as any;
                });
            });
    }
    getById(id: any): Promise<T> {
        // find item by id
        return this.db.get(id);
    }
    save(item: T): Promise<any> {
        // add or update an item depending on _id
        return this.saveAll([item]);
    }
    saveAll(items: T[]): Promise<any> {
        return this.db.bulkDocs(items);
    }
    // add(item: T): Promise<any> {
    //     // add new item
    //     return this.db.post(item);
    // }
    // async update(item: T): Promise<any> {
    //     // find item by id
    //     const updatingItem = await this.db.get((item as any)._id);

    //     // update item
    //     //Object.assign(updatingItem, item);
    //     return this.db.put(updatingItem);
    // }
    async delete(id: any): Promise<any> {
        // find item by id
        const item = await this.db.get(id);
        // remove item
        return this.db.remove(item);
    }
}
